/**
 * @fileoverview 掲載企業への情報提供の同意文言（デフォルト文言）
 *
 * @description
 *  資料・イベント・動画の問い合わせフォームで submit ボタン直上に常時表示する。
 *  Macau から入稿されたプライバシーポリシーは ButtonSubmit の caption 側で別途表示し、
 *  こちらはその有無に関わらず必ず出す（同意文言が入稿内容次第で欠落しないようにするため）。
 */
<script lang="ts">
import { defineComponent, computed } from 'vue'
import MessageSection from '@/components/message/MessageSection.vue'

export default defineComponent({
  name: 'PrivacyPolicyAgreement',

  components: {
    MessageSection,
  },

  props: {
    /** 情報提供先となる掲載企業名。未指定なら「掲載企業」と表示する */
    companyName: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const displayCompanyName = computed<string>(() => props.companyName || '掲載企業')

    return {
      displayCompanyName,
    }
  },
})
</script>

<template>
  <MessageSection
    status="info"
    slim>
    <template #header>
      <p class="p u-text__small u-text__center">
        提供先: {{ displayCompanyName }}への同意確認
      </p>
    </template>
    <template #description>
      <p class="p u-text__x-small u-text__center">
        上記を含むプロフィール情報・利用データが提供されます。
      </p>
    </template>
  </MessageSection>
</template>
